





































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { mixins } from 'vue-class-component'
import _ from 'lodash'
import SanIDModel from '@/_models/SanIDModel'

// Shared
import TablePagination from '@/components/shared/TablePagination.vue'
// Common
import NotFound from '@/components/common/NotFound.vue'
// Mixins
import TableSortMixin from '@/components/mixins/TableSortMixin.vue'

import * as DownloadCsv from 'vue-json-csv'
import { Filter } from '@/_utils/filter'

@Component({
  components: {
    DownloadCsv,
    NotFound,
    TablePagination,
  },
  filters: {},
})
export default class SanIDList extends mixins(TableSortMixin) {
  // data
  filterUtilTableSort: any = new Filter('filter_sanid_list_table_sort')
  filterUtilPage: any = new Filter('filter_sanidlist_page')
  pageFilters: any = {
    currentPage: 1,
    perPage: 10,
  }
  numofPage: number = 1
  searchQuery: string = ''
  selectedFilter: string = 'san_id'
  filedNameLUT: any = {
    san_id: 'SAN ID',
  }
  filedType: any[] = ['-', 'JCard', 'Smart JCard']

  // Export csv setting
  csvFile: any = null
  csvFields: any = ['san_id', 'pan_id', 'jbox_type', 'status']

  // methods
  convertFieldName(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedNameLUT[value]) as string
  }

  convertJBoxType(value: string): string | null {
    if (!value) {
      return null
    }
    return this.$t(this.filedType[value]) as string
  }

  // computed
  get sanids(): SanIDModel[] {
    const sanids = this.$store.state.sanids.all.items
    this.numofPage = Math.ceil(sanids.length / this.pageFilters.perPage)

    return sanids
  }

  get filteredData(): SanIDModel[] {
    const targetField: string = this.selectedFilter
    if (!this.sanids) {
      return []
    }

    return this.sanids.filter((item: any): boolean => {
      return (
        String(item[targetField])
          .toLowerCase()
          .indexOf(this.searchQuery.toLowerCase()) !== -1
      )
    })
  }

  get isLoading(): boolean {
    return this.$store.state.sanids.loading
  }

  // methods
  beforeDestroy() {
    this.filterUtilPage.save(this.pageFilters)
  }

  // After page created
  created() {
    this.pageFilters = this.filterUtilPage.get(this.pageFilters)
    this.$store.dispatch('sanids/getAll')
  }
}
